"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../shared/BaseTailoringQuestions";

interface IATailoringQuestionsProps {
  onBack?: () => void;
}

const QUESTIONS: TailoringQuestion[] = [
  {
    id: "INTAS-1",
    question:
      "Have we confirmed that all intangible assets recognized by the entity satisfy the definition of intangible asset as per AS 26 – Intangible Assets, i.e., identifiable, non-monetary asset without physical substance held for use in the production or supply of goods or services, for rental to others, or for administrative purposes?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "INTAS-2",
    question: "Has the entity capitalized any interest or salary on any asset during the year?",
    type: "radio",
    options: ["Yes", "No"],
  },
];

export default function IATailoringQuestions({ onBack }: IATailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Intangible Assets"
      title="Intangible Assets - Tailoring Questions"
      description="Answer entity-specific questions for Intangible Assets"
      questions={QUESTIONS}
      onBack={onBack}
    />
  );
}





